import { BigNumber } from '@ethersproject/bignumber'
import { createContext, useContext } from 'react'

export const GasPriceContext = createContext<
  | {
      delayGasPrice?: BigNumber
      networkGasPrice?: BigNumber
      networkGasTip?: BigNumber
      fastNetworkGasTip?: BigNumber
      averageNetworkGasTip?: BigNumber
      slowNetworkGasTip?: BigNumber
      baseFee?: BigNumber
      maxGasFee?: BigNumber
      maxGasFeeForEthMax?: BigNumber
      maxGasTipForEthMax?: BigNumber
      setMaxGasFeeForEthMax: (gasFee?: BigNumber) => void
    }
  | undefined
>(undefined)

export function useGasPrice() {
  return useContext(GasPriceContext)
}
